import axios from 'axios';
import {
  PropertyInformation,
  Taxes,
  Installment,
  WaterInfo,
  DropdownOption,
  ContextType,
  TaxExemption,
  ConfirmedAssessment,
  UnconfirmedAssessment,
  Lien,
  AddedOmittedAssessment,
  FormData,
  VprFee,
  SpecialImprovement,
  UtilityInfoForPdf,
  UtilityTypeInfo,
  UtilityInfoViewModel,
  SelectedMuniForUtilityType,
  PilotCharge,
  BaseLotTax,
} from './types';
import { useParams, useHistory } from 'react-router-dom';
import qs from 'qs';

import React, { createContext, useContext, useEffect, useState } from 'react';
import produce from 'immer';
import { updateSubStatus } from 'components/ProofingSubstatus/functions';
import { SetSubStatusObj } from 'components/ProofingWorkspace/types';
import { getNextLink } from 'components/forms/FormStepperFunctions';
import { globalArrayProduce } from 'lib/globalImmer';
import _ from 'lodash';
interface Props {
  children: React.ReactNode;
}

const installmentDates: { [key: string]: string } = {
  '0': '02-01',
  '1': '05-01',
  '2': '08-01',
  '3': '11-01',
};
const getYearOptions: () => DropdownOption[] = () => {
  const currentYear = new Date().getFullYear() + 1;
  return Array(35)
    .fill(35)
    .map((v, i) => ({ label: (currentYear - i).toString(), value: currentYear - i }));
};
const get10YearOptions: () => DropdownOption[] = () => {
  const currentYear = new Date().getFullYear() + 1;
  return Array(10)
    .fill(10)
    .map((v, i) => ({ label: (currentYear - i).toString(), value: currentYear - i }));
};
const baseExemption: TaxExemption = {
  type: { label: '', value: null },
  amount: '',
  otherAmountText: '',
  otherText: '',
};
const baseAssessment: ConfirmedAssessment = {
  orderNumber: '',
  confirmedDate: '',
  purpose: '',
  originalAssessment: null,
  numberOfInstallments: '',
  installmentAmount: null,
  dueDate: '',
  installmentsPaid: '',
  installmentsOpen: '',
  balance: '',
};
const baseUnconfirmed: UnconfirmedAssessment = {
  ordinanceNumber: '',
  dateAdopted: '',
  purpose: '',
};
const baseAddedOmitted: AddedOmittedAssessment = {
  year: '',
  amount: null,
  quarterNumber: null,
  status: null,
  additionalInfo: '',
};
const baseLien: Lien = {
  certificateNumber: '',
  saleDate: null,
  saleAmount: '',
  chargeType: '',
  yearInSale: '',
  subsequentCharges: '',
  additionalInfo: '',
  soldTo: '',
  lienCreationDate: '',
};
const baseSpecialImprovement: SpecialImprovement = {
  year: { label: '', value: null },
  quarter: '',
  additionalInfo: '',
  customDate: '',
};
const basePilotCharge: PilotCharge = {
  year: { label: '', value: null },
  quarter: '',
  additionalInfo: '',
  customDate: '',
};
const baseBaseLotTax: BaseLotTax = {
  year: { label: '', value: null },
  quarter: '',
  additionalInfo: '',
  customDate: '',
};
const createBaseVprFee = (additionalInfo?: string) => {
  return {
    year: { label: '', value: null },
    status: { label: '', value: null },
    amount: '',
    additionalInfo: additionalInfo || '',
    customDate: '',
  } as VprFee;
};

const addedOmittedAssessmentFactory = (
  setItem: React.Dispatch<React.SetStateAction<AddedOmittedAssessment[]>>
) => {
  const values: any = {
    0: '4th',
    1: '1st',
    2: '2nd',
  };
  let arr = [0, 1, 2];
  const res: any = arr.map(
    (val, index) =>
      ({
        amount: null,
        status: null,
        year: null,
        quarterNumber: null,
      } as any)
  );
  setItem(res);
};
const createInstallment = (year?: number, installmentNumber?: number) => {
  const installment: Installment = {
    dueDay:
      installmentNumber === undefined ? '' : `${year}-${installmentDates[installmentNumber.toString()]}`,
    amount: null,
    status: null,
    otherStatusOption: '',
    creditType: { label: '', value: null },
    additionalInformation: '',
  };

  return installment;
};

const factoryFunction: (year: number) => Installment[] = (year: number) => {
  const date = new Date();
  const currentYear = date.getFullYear();
  const control = year < currentYear ? [0] : year > currentYear ? [0, 1] : [0, 1, 2, 3];
  return control.map(index => createInstallment(year, index));
};
let initialPropertyInformation: PropertyInformation = {
  municipalCode: '',
  assessTo: '',
  assessorCode: { value: '', label: '' },
  propertySize: '',
  landAssessment: '',
  totalAssessment: '',
  improvement: '',
  taxRate: '',
  taxRatio: '',
  taxRatioYear: { value: '', label: '' },
  mailingAddress: '',
  xLots: '',
  isBankruptcy: false,
  wippLinkAddress: '',
  feedDate: '',
  muaFeedDate: '',
  waterLink: '',
  qualDiscrepancy: false,
  addressDiscrepancy: false,
  inTaxSale: false,
  priorBLQ: '',
  serviceLocationDiscrepancy: false,
};
const NJTaxSearchContext = createContext<ContextType | undefined>(undefined);

export const NJTaxSearchProvider = (props: Props) => {
  const [propertyInfo, setPropertyInfo] = useState<PropertyInformation>(initialPropertyInformation);
  const [taxes, setTaxes] = useState<Taxes[]>([] as Taxes[]);
  const [taxingAuthorities, setTaxingAuthorities] = useState<any>();
  const [water, setWater] = useState<WaterInfo[]>([]);
  var date = new Date().toISOString().substr(0, 10);
  const [vacantProperty, setVacantProperty] = useState(false);
  const [vacantPropertyAmount, setVacantPropertyAmount] = useState('');
  const [runDate, setRunDate] = useState(date);
  const [pdfHtml, setPdfHtml] = useState();
  const [loaderStatus, setLoaderStatus] = useState(false);
  const [property, setProperty] = useState<any>({});
  const [taxExemptions, setTaxExemptions] = useState<TaxExemption[]>([]);
  const [confirmedAssessments, setConfirmedAssessments] = useState<ConfirmedAssessment[]>([]);
  const [unconfirmedAssessments, setUnconfirmedAssessments] = useState<UnconfirmedAssessment[]>([]);
  const [vprFees, setVprFees] = useState<VprFee[]>([]);
  const [liens, setLiens] = useState<Lien[]>([]);
  const [searchId, setSearchId] = useState(0);
  const [specialImprovements, setSpecialImprovements] = useState<SpecialImprovement[]>([]);
  const [pilotCharges, setPilotCharges] = useState<PilotCharge[]>([]);
  const [baseLotTaxes, setBaseLotTaxes] = useState<BaseLotTax[]>([]);
  const [addedAssessment, setAddedAssessment] = useState<AddedOmittedAssessment[]>([]);
  const [omittedAssessment, setOmittedAssessment] = useState<AddedOmittedAssessment[]>([]);
  const [feedDate, setFeedDate] = useState<string>();
  const [muaFeedDate, setMuaFeedDate] = useState<string>();
  const [titleForNote, setTitleForNote] = useState('');
  const [miscNote, setMiscNote] = useState('');
  const params = useParams<{ propertyid: string }>();
  const [isContin, setIsContin] = useState(false);
  const [selectedMuniForUtilityType, setSelectedMuniForUtilityType] = useState<SelectedMuniForUtilityType>(
    {}
  );
  const [muniInfoForUtility, setMuniInfoForUtility] = useState<{
    [key: string]: {
      [key: string]: {
        public: any;
        private: any;
        'common meter': any;
      };
    };
  }>();
  const [utilityInfo, setUtilityInfo] = useState<UtilityInfoForPdf>();
  const [utilityInfoVM, setUtilityInfoVM] = useState<UtilityInfoViewModel[]>([]);
  const [defaultMuniServicedByOption, setDefaultMuniServicedByOption] = useState<DropdownOption>({
    value: 0,
    label: '',
  });
  const { push } = useHistory();

  useEffect(() => {
    axios.get(`/api/property/GetProperty/${params.propertyid}`).then(({ data: property }) => {
      setProperty(property);
      setDefaultMuniServicedByOption({ value: property.municipalityId, label: property.municipality });
      axios
        .get<FormData>(`/api/searches/getSaved?propertyId=${params.propertyid}&searchTypeId=20`)
        .then(({ data }) => {
          const currentYear = new Date().getFullYear();
          const initialTaxes: Taxes[] = [currentYear + 1, currentYear, currentYear - 1].map(year => {
            return {
              year: { label: year.toString(), value: year },
              installments: factoryFunction(year),
            };
          });

          if (data) {
            var taxData = data.taxes?.length ? data.taxes : initialTaxes;
            setPropertyInfo(data.propertyInfo || initialPropertyInformation);
            setTaxes(taxData || []);
            setWater(data.water || []);
            setAddedAssessment(data.addedAssessment || []);
            setConfirmedAssessments(data.confirmedAssessments || []);
            setUnconfirmedAssessments(data.unconfirmedAssessments || []);
            //setVprFees(data.vprFees || []);
            setLiens(data.liens || []);
            setSpecialImprovements(data.specialImprovements || []);
            setPilotCharges(data.pilotCharges || []);
            setBaseLotTaxes(data.baseLotTaxes || []);
            setTaxExemptions(data.taxExemptions || []);
            setOmittedAssessment(data.omittedAssessment || []);
            setVacantProperty(data.vacantProperty || false);
            setVacantPropertyAmount(data.vacantPropertyAmount || '');
            setFeedDate(data.feedDate);
            setMuaFeedDate(data.muaFeedDate);
            setMiscNote(data.miscNote || '');
            setTitleForNote(data.titleForNote || '');
          } else {
            setTaxes(initialTaxes);
            setWater([createWater()]);
          }
          setVprFees(data?.vprFees || []);
        });
    });
    axios.get(`/api/property/GetTaxingAuthorities/${params.propertyid}`).then(({ data }) => {
      setTaxingAuthorities(data.taxingAuthorities);
    });
  }, []);

  useEffect(() => {
    axios.get(`/api/searches/istaxcontin/${+params.propertyid}`).then(({ data: { isContin } }) => {
      setIsContin(isContin);
    });
    axios
      .get(`/api/searches/GetSearchByType/${20}/${+params.propertyid}`)
      .then(({ data }) => setSearchId(data.id));
  }, [params.propertyid]);

  useEffect(() => {
    if (property.municipalityId) {
      axios
        .get<UtilityInfoViewModel[]>(
          `/api/utilityInfo/GetUtilityServicedBy?municipalityId=${property.municipalityId}`
        )
        .then(({ data }) => {
          const actualInfo = data.map(d => ({
            ...d,
            servicedByMunis: [
              {
                value: property.municipalityId,
                label: property.municipality,
              },
            ].concat(d.servicedByMunis),
          }));
          setUtilityInfoVM(actualInfo);
          const newselectedMunis = produce(selectedMuniForUtilityType, draft => {
            water.forEach((w, i) => {
              draft[i] = data.map(d => {
                const utilityType = draft[i]?.find(i => i.utilityTypeId === d.utilityType.value);
                return (
                  utilityType || {
                    utilityTypeId: d.utilityType.value,
                    municipality: {
                      value: property.municipalityId,
                      label: property.municipality,
                    },
                    utilityType: d.utilityType.label,
                  }
                );
              });
            });
          });
          setSelectedMuniForUtilityType(newselectedMunis);
          if (!muniInfoForUtility) {
            const allUtilInfo: {
              [key: string]: {
                [key: string]: {
                  public: any;
                  private: any;
                  'common meter': any;
                };
              };
            } = {};
            for (let util of newselectedMunis[0]) {
              for (let muni of actualInfo.flatMap(s => s.servicedByMunis)) {
                getUtilityInfo({
                  municipality: muni,
                  utilityType: util.utilityType,
                  utilityTypeId: util.utilityTypeId,
                }).then(d => {
                  allUtilInfo[`${util.utilityTypeId}${muni.value}`] = d;
                });
              }
              setMuniInfoForUtility(allUtilInfo);
            }
          }
        });
    }
  }, [JSON.stringify(property), water.length]);

  const getAllPDFData = async (waterIndex: number) => {
    if (!muniInfoForUtility) {
      return {};
    }
    const promises = selectedMuniForUtilityType[waterIndex]?.map(s => {
      return muniInfoForUtility[`${s.utilityTypeId}${s.municipality.value}`];
    });
    if (!promises) {
      return {};
    }
    const resolved = await Promise.all(promises);
    return resolved.reduce((prev, cur) => {
      return { ...prev, ...cur };
    }, {});
  };

  const getUtilityInfo = async (selectedMuni: UtilityTypeInfo) => {
    const params = qs.stringify({
      municipalityId: selectedMuni.municipality.value,
      utilityTypeId: selectedMuni.utilityTypeId,
    });
    const { data } = await axios.get(`/api/utilityInfo/GetInfoForUtilityType?${params}`);

    return {
      [selectedMuni.utilityType?.toLowerCase() as string]: {
        public: data?.public || '',
        private: data?.private || '',
        'common meter': data?.commonMeter || '',
      },
    };
  };

  const changeTaxInfo = (taxIndex: number, label: keyof Taxes, value: any) => {
    const newTaxes = produce(taxes, draft => {
      draft[taxIndex][label] = value;
    });
    setTaxes(newTaxes);
  };
  const handlePreview = async () => {
    const formData = await getFormData();
    const { data: html } = await axios.post('/api/searches/CreatePDF', {
      template: 'NJTaxSearch',
      data: { ...formData },
      // JSON.stringify({"template":"NJTaxSearch","data":{"propertyInfo":{"municipalCode":"5432","assessTo":"fsdaf","assessorCode":{"value":"1 - Vacant Land","label":"1 - Vacant Land"},"propertySize":"4532","landAssessment":4321,"totalAssessment":5432,"improvement":8765},"taxes":[{"year":{"label":"2022","value":2022},"installments":[{"dueDay":"2022-02-01","amount":432,"status":{"label":"TBT","value":"TBT"},"otherStatusOption":"","homesteadCreditApplied":true,"homesteadCreditAmount":54325},{"dueDay":"2022-04-01","amount":7653,"status":{"label":"TBT","value":"TBT"},"otherStatusOption":"","homesteadCreditApplied":false,"homesteadCreditAmount":null}]},{"year":{"label":"2021","value":2021},"installments":[{"dueDay":"2021-02-01","amount":65436,"status":{"label":"Other","value":"Other"},"otherStatusOption":"6543","homesteadCreditApplied":false,"homesteadCreditAmount":null},{"dueDay":"2021-04-01","amount":6543,"status":{"label":"TBT","value":"TBT"},"otherStatusOption":"","homesteadCreditApplied":false,"homesteadCreditAmount":null},{"dueDay":"2021-08-01","amount":432,"status":{"label":"Other","value":"Other"},"otherStatusOption":"54325","homesteadCreditApplied":false,"homesteadCreditAmount":null},{"dueDay":"2021-11-01","amount":986876,"status":{"label":"TBT","value":"TBT"},"otherStatusOption":"","homesteadCreditApplied":false,"homesteadCreditAmount":null}]},{"year":{"label":"2020","value":2020},"installments":[{"dueDay":"2020-02-01","amount":5432,"status":{"label":"Paid","value":"Paid"},"otherStatusOption":"","homesteadCreditApplied":false,"homesteadCreditAmount":null},{"dueDay":"2020-04-01","amount":5432,"status":{"label":"Paid","value":"Paid"},"otherStatusOption":"","homesteadCreditApplied":false,"homesteadCreditAmount":null},{"dueDay":"2020-08-01","amount":345432,"status":{"label":"TBT","value":"TBT"},"otherStatusOption":"","homesteadCreditApplied":false,"homesteadCreditAmount":null},{"dueDay":"2020-11-01","amount":8764,"status":{"label":"TBT","value":"TBT"},"otherStatusOption":"","homesteadCreditApplied":false,"homesteadCreditAmount":null}]}],"water":[{"type":{"label":"Water/Sewer","value":"Water/Sewer"},"description":{"label":"Public","value":"Public"},"additionalInfo":"hello","accountNumber":"6543"}],"vacantProperty":true,"vacantPropertyAmount":4321,"runDate":"2021-11-15","searchTypeId":20,"propertyId":1387}})
    });
    setPdfHtml(html);
  };
  const getFormData = async () => {
    //const pdfUtilityInfoData = await getAllPDFData();
    const waterInfo = await Promise.all(
      water.map(async (w, i) => {
        return {
          ...w,
          pdfUtilityInfoData: await getAllPDFData(i),
        };
      })
    );
    return {
      propertyInfo,
      //pdfUtilityInfoData,
      taxes,
      water: waterInfo,
      vacantProperty,
      vacantPropertyAmount,
      runDate,
      searchTypeId: 20,
      searchType: 'Tax Search',
      propertyId: parseInt(params.propertyid),
      taxExemptions,
      addedAssessment,
      omittedAssessment,
      confirmedAssessments,
      unconfirmedAssessments,
      vprFees,
      liens,
      taxingAuthorities,
      specialImprovements,
      pilotCharges,
      baseLotTaxes,
      isContin,
      titleForNote,
      miscNote,
    };
  };
  const changeInstallmentInfo = (
    taxIndex: number,
    installmentIndex: number,
    label: keyof Installment,
    value: any
  ) => {
    const newtaxes = produce(taxes, draft => {
      const installment: Installment = draft[taxIndex].installments[installmentIndex];
      (installment as any)[label] = value;
    });
    setTaxes(newtaxes);
  };
  const changeWaterInfo = (waterIndex: number, label: keyof WaterInfo, value: any) => {
    const newWater = produce(water, draft => {
      (draft[waterIndex][label] as any) = value;
    });
    setWater(newWater);
  };
  const changePropertyInfo = (label: keyof Partial<PropertyInformation>, value: any) => {
    const newPropertyInfo = produce(propertyInfo, draft => {
      // draft[label] = value;
      (draft[label] as keyof PropertyInformation) = value;
    });
    setPropertyInfo(newPropertyInfo);
  };
  const addInstallment = (taxIndex: number) => {
    const newInstallment = produce(taxes, draft => {
      draft[taxIndex].installments.push(createInstallment());
    });
    setTaxes(newInstallment);
  };
  const addTaxYear = () => {
    const newTaxYear = produce(taxes, draft => {
      draft.push({ year: { label: '', value: null }, installments: [createInstallment()] });
    });
    setTaxes(newTaxYear);
  };

  const createWater = () => {
    const water: WaterInfo = {
      type: { label: '', value: null },
      description: { label: '', value: null },
      additionalInfo: '',
      accountNumber: '',
      amount: '',
      status: { label: '', value: null },
      priorAmountDue: '',
      priorAmountStatus: { label: '', value: null },
      delinquentAmount: '',
      delinquentStatus: { label: '', value: null },
      dateRange: '',
      waterInfoServiceLocation: '',
    };

    return water;
  };

  const addWater = () => {
    const addedWater = createWater();
    const newWater = produce(water, draft => {
      draft.push(addedWater);
    });
    setWater(newWater);
  };
  const deleteWater = (indexToRemove: number) => {
    const newWaters = water.filter((w, index) => index !== indexToRemove);
    setWater(newWaters);
  };
  const deleteYear = (indexToRemove: number) => {
    const newYears = taxes.filter((t, index) => index !== indexToRemove);
    setTaxes(newYears);
  };
  const deleteInstallment = (indexToRemove: number, taxIndex: number) => {
    const newInstallments = produce(taxes, draft => {
      draft[taxIndex].installments.splice(indexToRemove, 1);
    });
    setTaxes(newInstallments);
  };
  const handleDownload = async (substatus: SetSubStatusObj) => {
    setLoaderStatus(true);
    const formData = await getFormData();
    await axios.post('/api/searches/DownloadPDF', {
      template: 'njTaxSearch',
      data: { ...formData, fromAutomation: false }, //await getFormContent()
    });
    // await updateSubStatus(substatus);
    const nextLink = getNextLink(property.orderId, 20, params.propertyid);
    if (nextLink == null) {
      push(`/orders/order-information/${property.orderId}`);
    } else {
      push(nextLink);
    }

    setLoaderStatus(false);
  };
  const createExemption = () => {
    const newExemptions = [...taxExemptions];
    newExemptions.push(baseExemption);
    setTaxExemptions(newExemptions);
  };
  const changeTaxExemptions = (label: keyof Partial<TaxExemption>, value: any, index: number) => {
    const newExemptions = produce(taxExemptions, draft => {
      draft[index][label] = value;
      if (label === 'type') {
        draft[index].amount = value.label === 'Fully Disabled Veteran' ? null : '250';
        draft[index].otherAmountText = value.label === 'Fully Disabled Veteran' ? 'Tax Exempt' : '';
      }
    });
    setTaxExemptions(newExemptions);
  };
  const deleteExemption = (indexToRemove: number) => {
    const newExemptions = taxExemptions.filter((te, index) => index !== indexToRemove);
    setTaxExemptions(newExemptions);
  };
  const createAssessment = () => {
    const newAssessments = [...confirmedAssessments];
    newAssessments.push(baseAssessment);
    setConfirmedAssessments(newAssessments);
  };
  const changeAssessment = (label: keyof Partial<ConfirmedAssessment>, value: any, index: number) => {
    const newAssessments = produce(confirmedAssessments, draft => {
      draft[index][label] = value;
    });
    setConfirmedAssessments(newAssessments);
  };
  const deleteAssessment = (indexToRemove: number) => {
    const newAssessments = confirmedAssessments.filter((ca, index) => index !== indexToRemove);
    setConfirmedAssessments(newAssessments);
  };
  const createUnconfirmedAssessment = () => {
    const newUnconfirmedAssessments = [...unconfirmedAssessments];
    newUnconfirmedAssessments.push(baseUnconfirmed);
    setUnconfirmedAssessments(newUnconfirmedAssessments);
  };
  const changeUnconfirmedAssessment = (
    label: keyof Partial<UnconfirmedAssessment>,
    value: any,
    index: number
  ) => {
    const newUnconfirmedAssessments = produce(unconfirmedAssessments, draft => {
      draft[index][label] = value;
    });
    setUnconfirmedAssessments(newUnconfirmedAssessments);
  };
  const deleteUnconfirmedAssessments = (indexToRemove: number) => {
    const newUnconfirmedAssessments = unconfirmedAssessments.filter((una, index) => index !== indexToRemove);
    setUnconfirmedAssessments(newUnconfirmedAssessments);
  };
  const createVprFee = () => {
    const newVprFees = [...vprFees];
    newVprFees.push(createBaseVprFee());
    setVprFees(newVprFees);
  };
  const changeVprFee = (label: keyof Partial<VprFee>, value: any, index: number) => {
    const newVprFees = produce(vprFees, draft => {
      draft[index][label] = value;
    });
    setVprFees(newVprFees);
  };
  const deleteVprFee = (indexToRemove: number) => {
    const newVprFees = vprFees.filter((vpr, index) => index !== indexToRemove);
    setVprFees(newVprFees);
  };
  const createLien = () => {
    const newLiens = [...liens];
    newLiens.push(baseLien);
    setLiens(newLiens);
  };
  const changeLien = (label: keyof Partial<Lien>, value: any, index: number) => {
    const newLiens = produce(liens, draft => {
      draft[index][label] = value;
    });
    setLiens(newLiens);
  };
  const deleteLien = (indexToRemove: number) => {
    const newLiens = liens.filter((w, index) => index !== indexToRemove);
    setLiens(newLiens);
  };
  const createSpecialImprovement = () => {
    const newSpecialImprovements = [...specialImprovements];
    newSpecialImprovements.push(baseSpecialImprovement);
    setSpecialImprovements(newSpecialImprovements);
  };
  const changeSpecialImprovement = (label: keyof Partial<SpecialImprovement>, value: any, index: number) => {
    const newSpecialImprovements = produce(specialImprovements, draft => {
      draft[index][label] = value;
    });
    setSpecialImprovements(newSpecialImprovements);
  };
  const deleteSpecialImprovement = (indexToRemove: number) => {
    const newSpecialImprovements = specialImprovements.filter((si, index) => index !== indexToRemove);
    setSpecialImprovements(newSpecialImprovements);
  };
  const createPilotCharge = () => {
    const newPilotCharges = [...pilotCharges];
    newPilotCharges.push(basePilotCharge);
    setPilotCharges(newPilotCharges);
  };
  const createBaseLotTax = () => {
    const newBaseLotTaxes = [...baseLotTaxes];
    newBaseLotTaxes.push(baseBaseLotTax);
    setBaseLotTaxes(newBaseLotTaxes);
  };
  const changePilotCharge = (label: keyof Partial<PilotCharge>, value: any, index: number) => {
    const newPilotCharges = produce(pilotCharges, draft => {
      draft[index][label] = value;
    });
    setPilotCharges(newPilotCharges);
  };
  const changeBaseLotTax = (label: keyof Partial<BaseLotTax>, value: any, index: number) => {
    const newBaseLotTaxes = produce(baseLotTaxes, draft => {
      draft[index][label] = value;
    });
    setBaseLotTaxes(newBaseLotTaxes);
  };
  const deletePilotCharge = (indexToRemove: number) => {
    const newPilotCharges = pilotCharges.filter((pc, index) => index !== indexToRemove);
    setPilotCharges(newPilotCharges);
  };
  const deleteBaseLotTax = (indexToRemove: number) => {
    const newBaseLotTaxes = baseLotTaxes.filter((blt, index) => index !== indexToRemove);
    setBaseLotTaxes(newBaseLotTaxes);
  };
  const createOmitted = () => {
    const newOmitted = [...omittedAssessment];
    newOmitted.push(baseAddedOmitted);
    setOmittedAssessment(newOmitted);
  };
  const createAdded = () => {
    const newAdded = [...addedAssessment];
    newAdded.push(baseAddedOmitted);
    setAddedAssessment(newAdded);
  };
  const deleteAdded = (indexToRemove: number) => {
    const newAdded = addedAssessment.filter((aa, index) => index !== indexToRemove);
    setAddedAssessment(newAdded);
  };
  const changeOmitted = (label: keyof Partial<AddedOmittedAssessment>, value: any, index: number) => {
    const newOmitted = produce(omittedAssessment, draft => {
      draft[index][label] = value;
    });
    setOmittedAssessment(newOmitted);
  };
  const changeAdded = (label: keyof Partial<AddedOmittedAssessment>, value: any, index: number) => {
    const newAdded = produce(addedAssessment, draft => {
      draft[index][label] = value;
    });
    setAddedAssessment(newAdded);
  };
  const deleteOmitted = (indexToRemove: number) => {
    const newOmitted = omittedAssessment.filter((oa, index) => index !== indexToRemove);
    setOmittedAssessment(newOmitted);
  };
  const updateUtilityInfo = (index: number, value: DropdownOption, waterIndex: number) => {
    const newSelectedMuniType = produce(selectedMuniForUtilityType, draft => {
      draft[waterIndex][index].municipality = value;
    });
    setSelectedMuniForUtilityType(newSelectedMuniType);
  };
  return (
    <NJTaxSearchContext.Provider
      value={{
        propertyInfo,
        changePropertyInfo,
        changeTaxInfo,
        taxes,
        changeInstallmentInfo,
        addInstallment,
        changeWaterInfo,
        water,
        addTaxYear,
        getYearOptions,
        addWater,
        deleteInstallment,
        deleteWater,
        deleteYear,
        vacantProperty,
        setVacantProperty,
        vacantPropertyAmount,
        setVacantPropertyAmount,
        runDate,
        setRunDate,
        pdfHtml,
        handlePreview,
        handleDownload,
        taxExemptions,
        createExemption,
        changeTaxExemptions,
        createAssessment,
        changeAssessment,
        deleteAssessment,
        confirmedAssessments,
        createUnconfirmedAssessment,
        changeUnconfirmedAssessment,
        unconfirmedAssessments,
        createLien,
        changeLien,
        liens,
        deleteLien,
        addedAssessment,
        deleteUnconfirmedAssessments,
        omittedAssessment,
        getFormData,
        loaderStatus,
        createAdded,
        createOmitted,
        changeAdded,
        changeOmitted,
        deleteAdded,
        deleteOmitted,
        deleteExemption,
        feedDate,
        muaFeedDate,
        createVprFee,
        changeVprFee,
        deleteVprFee,
        vprFees,
        get10YearOptions,
        createSpecialImprovement,
        changeSpecialImprovement,
        deleteSpecialImprovement,
        specialImprovements,
        createPilotCharge,
        changePilotCharge,
        deletePilotCharge,
        pilotCharges,
        searchId,
        titleForNote,
        setTitleForNote,
        miscNote,
        setMiscNote,
        utilityInfoVM,
        selectedMuniForUtilityType,
        updateUtilityInfo,
        createBaseLotTax,
        changeBaseLotTax,
        deleteBaseLotTax,
        baseLotTaxes,
      }}
    >
      {props.children}
    </NJTaxSearchContext.Provider>
  );
};
export function useNJTaxSearch() {
  const context = useContext(NJTaxSearchContext);
  return context;
}
